'use strict';

var Reflux = require('reflux');

var ProjectActions = Reflux.createActions(["loadAll", "create", "delete", "edit", "submit", "assignUser", "assignTeam", "assignDatasource", "unassignUser", "unassignTeam", "unassignDatasource", "changeUserRole", "startDragging", "updateDrag", "stopDragging", "addModule", "copy", "leave"]);

module.exports = ProjectActions;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/actions/project.js
 **/